/*
 * Enums.
 */

export enum PerformanceInteractionTypesEnum {
  CELLS_FETCH = 'cells_fetch',
  CELLS_SCROLL = 'cells_scroll',
  VIEWER_FETCH = 'viewer_fetch',
  VIEWER_SCROLL = 'viewer_scroll',
  TEXT_INPUT = 'text_input',
  MESSAGE_REPLY = 'message_reply',
  SEND_MESSAGE = 'send_message',
  SEND_COMMENT = 'send_comment',
  CELLS_SWIPE_ACTION = 'cells_swipe_action',
  OVERLAY_DISPLAY = 'overlay_display',
  CONVERSATION_ACTION = 'conversation_action',
  TEST = 'test', // Used for testing.
}

export enum PerformanceInteractionStepsEnum {
  // Event handler execution started.
  HANDLER_START = 'handler_start',
  // UI updated immediately after event.
  UI_UPDATE = 'ui_update',
  // Fetched data from network.
  NETWORK_FETCH = 'network_fetch',
  // Fetched data from cache.
  CACHE_FETCH = 'cache_fetch',
  // Fetched most recent composer content
  COMPOSER_FLUSH = 'composer_flush',
  // UI rendered in response to new data.
  RENDER = 'render',
}
